import { z } from "zod";

export type IReadAccess = z.infer<typeof TReadAccess>;
export const TReadAccess = z.object({
  companies: z.optional(z.array(z.string())),
  properties: z.optional(z.array(z.string())),
  propertyRoles: z.optional(z.array(z.string())),
  roles: z.optional(z.array(z.number())),
  contractorGroups: z.optional(z.array(z.string())),
  users: z.optional(z.array(z.string())),
  propertyUnits: z.optional(z.array(z.string())),
});
